import React from "react";

const SwAlert = ({
  variant = "info",   // success | warning | danger | info
  icon = null,        // pass JSX icon manually
  children,
  className = "",
  ...rest
}) => {
  return (
    <div
      className={`SwAlert SwAlert-${variant} ${className}`}
      role="alert"
      {...rest}
    >
      {icon && <span className="SwAlertIcon">{icon}</span>}

      <span className="SwAlertText">
        {children}
      </span>
    </div>
  );
};

export default SwAlert;